var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "app_markdown",
    class: {
      remove_default_max_width: _vm.removeDefaultMaxWidth
    }
  }, [_vm.label ? _c('div', {
    staticClass: "app_markdown__label",
    class: {
      required: _vm.required && !_vm.value
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('div', {
    staticClass: "app_markdown__component"
  }, [_c('div', {
    staticClass: "app_markdown__toolbar c-flex align-items-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center"
  }, [!_vm.isPreviewing ? _c('ButtonGeneric', {
    attrs: {
      "small": "",
      "color": "var(--c-default-border-color)"
    },
    on: {
      "click": _vm.uiClickOfPreview
    }
  }, [_vm._v(" Preview ")]) : _vm._e(), _vm.isPreviewing ? _c('ButtonGeneric', {
    attrs: {
      "small": "",
      "text-color": "var(--cosmic-text)",
      "flat": ""
    },
    on: {
      "click": _vm.uiClickOfContinueEditing
    }
  }, [_vm._v(" Continue editing ")]) : _vm._e(), _c('v-slide-y-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [!_vm.isPreviewing ? _c('div', {
    staticClass: "app_markdown__toolbar_text_formatting c-flex"
  }, [_c('ButtonMiniAction', {
    attrs: {
      "icon-size": _vm.TOOLBAR_ICON_SIZE,
      "icon-color": "var(--cosmic-text)",
      "icon": "fa-regular fa-bold",
      "tooltip": "Add bold text",
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.applyFormat('bold');
      }
    }
  }), _c('ButtonMiniAction', {
    attrs: {
      "disabled": _vm.disabled,
      "icon-size": _vm.TOOLBAR_ICON_SIZE,
      "icon-color": "var(--cosmic-text)",
      "icon": "fa-regular fa-italic",
      "tooltip": "Add italic text"
    },
    on: {
      "click": function ($event) {
        return _vm.applyFormat('italic');
      }
    }
  }), _c('ButtonMiniAction', {
    attrs: {
      "disabled": _vm.disabled,
      "icon-size": _vm.TOOLBAR_ICON_SIZE,
      "icon-color": "var(--cosmic-text)",
      "icon": "fa-regular fa-strikethrough",
      "tooltip": "Add strikethrough text"
    },
    on: {
      "click": function ($event) {
        return _vm.applyFormat('strikethrough');
      }
    }
  }), _c('div', {
    staticClass: "c-flex",
    staticStyle: {
      "border-left": "1px solid",
      "padding": "0 1rem"
    }
  }, [_c('c-popover', {
    attrs: {
      "align": "center",
      "min-height": "100px",
      "side": "bottom"
    }
  }, [_c('ButtonMiniAction', {
    attrs: {
      "slot": "activator",
      "disabled": _vm.hasCurrentUserSelection || _vm.disabled,
      "icon-size": _vm.TOOLBAR_ICON_SIZE,
      "tooltip": `${_vm.hasCurrentUserSelection ? 'Deselect text' : 'Insert table'}`,
      "icon-color": "var(--cosmic-text)",
      "icon": "fa-regular fa-table"
    },
    slot: "activator"
  }), _c('div', {
    staticStyle: {
      "width": "250px",
      "border": "var(--c-input-border, var(--c-default-input-border))"
    }
  }, [_c('div', {
    staticClass: "c-flex align-center pa-2"
  }, [_c('AppNumber', {
    model: {
      value: _vm.insertTableXValue,
      callback: function ($$v) {
        _vm.insertTableXValue = $$v;
      },
      expression: "insertTableXValue"
    }
  }), _vm._v(" x "), _c('AppNumber', {
    model: {
      value: _vm.insertTableYValue,
      callback: function ($$v) {
        _vm.insertTableYValue = $$v;
      },
      expression: "insertTableYValue"
    }
  })], 1), _c('ButtonGeneric', {
    staticClass: "my-2",
    attrs: {
      "small": "",
      "icon": "fa-regular fa-table"
    },
    on: {
      "click": _vm.uiClickOfInsertTable
    }
  }, [_vm._v(" Insert a "), _c('span', {
    staticClass: "monospace_font px-1"
  }, [_vm._v(_vm._s(_vm.insertTableXValue))]), _vm._v(" by "), _c('span', {
    staticClass: "monospace_font px-1"
  }, [_vm._v(_vm._s(_vm.insertTableYValue))]), _vm._v(" table ")])], 1)], 1), _c('ButtonMiniAction', {
    attrs: {
      "icon-color": "var(--cosmic-text)",
      "icon-size": _vm.TOOLBAR_ICON_SIZE,
      "icon": "fa-regular fa-book-sparkles",
      "tooltip": "Add a quick action (coming soon)",
      "disabled": ""
    },
    on: {
      "click": _vm.uiClickOfQuickAction
    }
  })], 1)], 1) : _vm._e()])], 1)]), _c('v-slide-y-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [!_vm.isPreviewing ? _c('div', {
    staticClass: "app_markdown__editor"
  }, [_c('textarea', {
    ref: "textarea",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": _vm.onKeyDown
    }
  }), _vm.isUsingSlashMenu ? _c('div', {
    ref: "mirror",
    staticClass: "mirror",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e()]), _vm.isUsingSlashMenu ? _c('c-popover', {
    staticClass: "app_markdown__slash_menu",
    domProps: {
      "isOpen": _vm.shouldShowSlashMenu,
      "position": _vm.slashMenuPosition
    },
    on: {
      "c-toggle": function ($event) {
        _vm.shouldShowSlashMenu = $event.detail;
      }
    }
  }, [_vm._t("slash-menu")], 2) : _vm._e(), _c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('AppMarkdownDisplay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPreviewing,
      expression: "isPreviewing"
    }],
    staticClass: "app_markdown__preview",
    attrs: {
      "markdown": _vm.markdownDisplayValue
    }
  })], 1)], 1), _c('div', {
    staticClass: "app_markdown__chin",
    class: {
      no_message: !_vm.required || _vm.value
    }
  }, [_c('v-slide-x-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_vm.required && !_vm.value ? _c('span', {
    staticClass: "message error_message"
  }, [_vm._v("* Required ")]) : _vm._e()])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };